import { create } from "zustand"

import { subscribeWithSelector } from "zustand/middleware"

import { generateTinyId } from "../utils/nanoidUtils"

export const useCameraStore = create(
  subscribeWithSelector((set) => ({
    enabled: true,
    enableControls: () => set({ enabled: true }),
    disableControls: () => set({ enabled: false }),
    recenterCamera: null,
    zoomTarget: null,
    triggerRecenterCamera: () => {
      const id = generateTinyId()
      set({ recenterCamera: id })
    },
    setZoomTarget: (position) => set({ zoomTarget: position }),
    clearZoomTarget: () => set({ zoomTarget: null }),
    resetCameraStore: () =>
      set({
        recenterCamera: null,
        zoomTarget: null,
        enabled: true,
      }),
  }))
)
